module.exports = __webpack_public_path__ + "static/media/reading.bcec1fd9.png";